import { observer } from 'mobx-react-lite';
import React from 'react';
import { EditorTileInspector } from "./EditorTileInspector";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaste } from '@fortawesome/free-solid-svg-icons';
import { MenuCard } from '../menu/MenuCard';
import { getLocalizedDynamicMapElementDisplayNameWithPosition } from '../../helper/displayHelpers';
import { useTranslation } from 'react-i18next';
import { undoableMapEditorDynamicMapElementPaste } from '../../stores/undo/operation/MapEditorSubmitCurrentMapDynamicMapElementsChangesOp';
import { DynamicMapElementPropertiesEditor } from './DynamicMapElementPropertiesEditor';
import { InteractionTriggerTilePropertiesEditor } from './InteractionTriggerTilePropertiesEditor';
import { LayerEditButton } from './EditorTileInspectorLayer';
import styled from 'styled-components';
import { DebugStartMarkerPropertiesEditor } from './DebugStartMarkerPropertiesEditor';
import { Adjustment, SlideMenu, State } from '../menu/SlideMenu';
import { undoableMapEditorSelectTile } from '../../stores/undo/operation/MapEditorEntitySelectionOp';
import { MdContentPasteOff } from 'react-icons/md';
import { undoableMapEditorClearDynamicMapElementClipboard } from '../../stores/undo/operation/MapEditorClearDynamicMapElementClipboard';
const PasteButton = styled(LayerEditButton).withConfig({
  displayName: "TileInspector__PasteButton",
  componentId: "sc-1k385ol-0"
})(["float:right;"]);
const TopPadding = styled.div.withConfig({
  displayName: "TileInspector__TopPadding",
  componentId: "sc-1k385ol-1"
})(["padding:14px;"]);
const inspectorMenuTop = 40;
const assetsMenuHeight = 260;
export const TileInspector = observer(({
  mapEditorStore,
  hideEditorTileInspector = false
}) => {
  const {
    t
  } = useTranslation();
  const {
    cutDynamicMapElement,
    currentMapStore
  } = mapEditorStore;
  if (!mapEditorStore.hasSelectedTile) return null;
  if (hideEditorTileInspector && !currentMapStore.isUserAllowedToEditCurrentMap) return null;
  return /*#__PURE__*/React.createElement(SlideMenu, {
    identifier: "inspector",
    orientation: Adjustment.Right,
    start: inspectorMenuTop,
    width: 290,
    maxHeight: `calc(100vh - ${inspectorMenuTop}px - ${assetsMenuHeight}px)`,
    state: State.Expanded,
    collapsible: true,
    ignorePersistedExpansionState: true,
    notAnimated: true,
    onUserToggle: () => undoableMapEditorSelectTile(null, mapEditorStore, false)
  }, !hideEditorTileInspector && /*#__PURE__*/React.createElement(EditorTileInspector, {
    mapEditorStore: mapEditorStore
  }), hideEditorTileInspector && /*#__PURE__*/React.createElement(TopPadding, null), mapEditorStore.hasCutDynamicMapElement && /*#__PURE__*/React.createElement(MenuCard, null, getLocalizedDynamicMapElementDisplayNameWithPosition(t, cutDynamicMapElement, false), "\xA0", /*#__PURE__*/React.createElement(PasteButton, {
    onClick: () => undoableMapEditorDynamicMapElementPaste(mapEditorStore.selectedTilePosition, mapEditorStore)
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPaste
  })), /*#__PURE__*/React.createElement(PasteButton, {
    onClick: () => undoableMapEditorClearDynamicMapElementClipboard(mapEditorStore)
  }, /*#__PURE__*/React.createElement(MdContentPasteOff, null))), currentMapStore.isUserAllowedToEditCurrentMap && /*#__PURE__*/React.createElement(React.Fragment, null, mapEditorStore.selectedInteractionTriggerTiles.map(tileData => /*#__PURE__*/React.createElement(InteractionTriggerTilePropertiesEditor, {
    key: tileData.$modelId,
    tileData: tileData,
    currentMapStore: currentMapStore
  })), mapEditorStore.selectedDynamicMapElements.map(element => /*#__PURE__*/React.createElement(DynamicMapElementPropertiesEditor, {
    key: element.$modelId,
    element: element,
    mapEditorStore: mapEditorStore
  })), mapEditorStore.selectedDebugStartMarker && /*#__PURE__*/React.createElement(DebugStartMarkerPropertiesEditor, null)));
});